import auth from "@/services/ExerciseInitAuth"

const list = query =>
  auth.get(`${process.env.VUE_APP_EXERCISE_API}admin/chapter_categories/`, {
    params: query
  });
// const list = query =>
//   auth.get(`${process.env.VUE_APP_EXERCISE_API}nu_exams/chapters/with_stats_v2/`, {
//     params: query
//   });

const remove = ID => 
  auth.delete(`${process.env.VUE_APP_EXERCISE_API}admin/chapter_categories/${ID}/`)

const put = (ID, data) => 
  auth.put(`${process.env.VUE_APP_EXERCISE_API}admin/chapter_categories/${ID}/`, data)

const create = data =>
  auth.post(`${process.env.VUE_APP_EXERCISE_API}admin/chapter_categories/`, data);

const sort = data =>
  auth.post(`${process.env.VUE_APP_EXERCISE_API}admin/chapter_categories/sort/`, data);

export default {
  list,
  remove,
  create,
  sort,
  put
}